import { render, staticRenderFns } from "./OpenLayerMapBox.vue?vue&type=template&id=4b06765b&scoped=true"
import script from "./OpenLayerMapBox.vue?vue&type=script&lang=js"
export * from "./OpenLayerMapBox.vue?vue&type=script&lang=js"
import style0 from "./OpenLayerMapBox.vue?vue&type=style&index=0&id=4b06765b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06765b",
  null
  
)

export default component.exports